import React from 'react';
import { Box } from 'lmc-ui-library';
import { CaseDetails } from '../../CaseDetailsPage.types';
import { SubPageTemplate } from '../../partials';

interface Props {
  resources: CaseDetails['resources'];
}

const RepaymentStrategy: React.FC<Props> = ({ resources }) => {
  return (
    <SubPageTemplate title="Repayment strategy">
      <Box>
        <Box.Content>No repayment strategy is required</Box.Content>
      </Box>
    </SubPageTemplate>
  );
};

export default RepaymentStrategy;
